import styled from 'styled-components'
import { tokens } from '@arvoreeducacao/bonsai-ds'
import type { ModalProps } from 'components/lib/modals'
import Modal from 'components/lib/modals/Modal'

export const StyledModal = styled(Modal)<ModalProps>`
  padding: 12px;
  width: 90%;
  border-radius: ${tokens.radius.xlarge};
  top: 25%;
  position: sticky;

  @media (min-width: ${tokens.sizes.smScreen}px) {
    width: 600px;
  }
`

export const Description = styled.div`
  text-align: left;
  font-weight: normal;
  font-size: ${tokens.sizes.text}px;
  line-height: 28px;
  color: ${tokens.colors.black4};
  margin: 16px 0;
`

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: ${tokens.spacing.verticalXlarge};
`
export const Title = styled.h1`
  margin: 0;
  color: ${tokens.colors.dark6};
  font-size: ${tokens.sizes.h[2].default};
  font-weight: ${tokens.fontWeights.bold};
  line-height: ${tokens.lineHeight.medium}%;
`
